// RouteModal.jsx
import React, { useState, useEffect } from 'react';
import api from '../../../../services/api';
import styles from './RouteModal.module.css';

const statusColors = {
  Закрыта: 'green',
  'Не доставлено': 'red',
  Открыта: 'blue',
};

// Компонент, который показывает подробности по одной квитанции в тултипе
// Компонент, который показывает подробности по одной квитанции в тултипе
const PopupContent = ({ receipt, orderNumber, delta }) => {
  const copyToClipboard = txt => navigator.clipboard.writeText(txt);

  const formatDiff = ms => {
    const totalSec = Math.floor(ms / 1000);
    const h = String(Math.floor(totalSec / 3600)).padStart(2, '0');
    const m = String(Math.floor((totalSec % 3600) / 60)).padStart(2, '0');
    const s = String(totalSec % 60).padStart(2, '0');
    return `${h}:${m}:${s}`;
  };

  const getStatusColor = status => {
    if (status === 'Закрыта') return '#28a745';
    if (status === 'Не доставлено') return '#ef4444';
    if (status === 'Открыта') return '#3b82f6';
    return '#999';
  };

  return (
    <div className={styles.tooltipContent}>
      {orderNumber != null && (
        <p><b>№ в истории:</b> {orderNumber}</p>
      )}

      <p>
        <b>Квитанция:</b>{' '}
        <span
          className={styles.link}
          onClick={() => copyToClipboard(receipt.receipt_number)}
        >
          {receipt.receipt_number}
        </span>
      </p>

      <p>
        <b>Договор:</b>{' '}
        <span
          className={styles.link}
          onClick={() => copyToClipboard(receipt.contract_number)}
        >
          {receipt.contract_number}
        </span>
      </p>

      <p>
        <b>Клиент:</b> {receipt.client_name}
      </p>

      <p>
        <b>Адрес:</b>{' '}
        <span
          className={styles.link}
          onClick={() => copyToClipboard(receipt.delivery_address)}
        >
          {receipt.delivery_address}
        </span>
      </p>

      <p>
        <b>Статус:</b>{' '}
        <span style={{ color: getStatusColor(receipt.status) }}>
          {receipt.status}
        </span>
      </p>

      <p>
        <b>Изменён:</b>{' '}
        {receipt.status_changed_at
          ? new Date(receipt.status_changed_at).toLocaleTimeString('ru-RU', {
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hour12: false,
            })
          : '-'}
      </p>

      {delta != null && (
        <p><b>Δ от предыдущего:</b> {formatDiff(delta)}</p>
      )}

      {receipt.reason && receipt.reason.trim() !== '' && (
        <p><b>Причина:</b> {receipt.reason}</p>
      )}

      <div>
        <b>Товары:</b>
        <ul className={styles.productsList}>
          {(receipt.products || []).map((product, index) => {
            const scannedCount = Array.isArray(product.marks) ? product.marks.length : 0;
            return (
              <li key={index}>
                {product.product_name} x{product.actual_quantity} шт.{' '}
                {product.is_marked && (
                  <span>
                    Скан: {scannedCount}/{product.actual_quantity}
                  </span>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};


export default function RouteModal({ routeId, onClose }) {
  const [route, setRoute] = useState(null);
  const [activeDrivers, setActiveDrivers] = useState([]);
  const [activeLoaders, setActiveLoaders] = useState([]);
  const [driver, setDriver] = useState('');
  const [loader1, setLoader1] = useState('');
  const [loader2, setLoader2] = useState('');
  const [saving, setSaving] = useState(false);
  const [hovered, setHovered] = useState({ receipt: null, order: null, delta: null, x: 0, y: 0 });

  useEffect(() => {
    // Загрузка деталей маршрута
    api.get(`/routes/${routeId}`)
      .then(res => {
        const p = res.data ?? res;
        setRoute(p);
        setDriver(p.driver || '');
        setLoader1(p.loader1 || '');
        setLoader2(p.loader2 || '');
      })
      .catch(() => {
        alert('Не удалось загрузить детали маршрута');
        onClose();
      });

    // Загрузка активного персонала
    api.get('/routes/active-personnel')
      .then(res => {
        const p = res.data ?? res;
        setActiveDrivers(p.drivers || []);
        setActiveLoaders(p.loaders || []);
      })
      .catch(() => {
        setActiveDrivers([]);
        setActiveLoaders([]);
      });
  }, [routeId, onClose]);

  const saveChanges = async () => {
    setSaving(true);
    try {
      await api.patch(`/routes/${routeId}/personnel`, { driver, loader1, loader2 });
      await api.patch(`/routes/${routeId}/status`, { route_status: 'Исполнен' });
      onClose(true);
    } catch {
      alert('Ошибка при сохранении');
    } finally {
      setSaving(false);
    }
  };

  if (!route) return null;

  const { receipts, route_number, route_date, route_districts, car } = route;
  let lastTime = null;

  return (
    <>
      <div className={styles.overlay} onClick={() => onClose(false)} />

      <div className={styles.content}>
        <button className={styles.closeButton} onClick={() => onClose(false)}>×</button>
        <h2 className={styles.title}>Маршрут №{route_number}</h2>
        <p className={styles.meta}>{route_date} | {route_districts} | {car}</p>

        {/* Строки селектов */}
        <div className={styles.formRow}>
          <label>Водитель:</label>
          <select value={driver} onChange={e => setDriver(e.target.value)}>
            {driver && !activeDrivers.includes(driver) && (
              <option value={driver}>{driver} (текущий)</option>
            )}
            <option value="">—</option>
            {activeDrivers.map(d => <option key={d} value={d}>{d}</option>)}
          </select>
        </div>
        <div className={styles.formRow}>
          <label>Грузчик 1:</label>
          <select value={loader1} onChange={e => setLoader1(e.target.value)}>
            {loader1 && !activeLoaders.includes(loader1) && (
              <option value={loader1}>{loader1} (текущий)</option>
            )}
            <option value="">—</option>
            {activeLoaders.map(l => <option key={l} value={l}>{l}</option>)}
          </select>
        </div>
        <div className={styles.formRow}>
          <label>Грузчик 2:</label>
          <select value={loader2} onChange={e => setLoader2(e.target.value)}>
            {loader2 && !activeLoaders.includes(loader2) && (
              <option value={loader2}>{loader2} (текущий)</option>
            )}
            <option value="">—</option>
            {activeLoaders.map(l => <option key={l} value={l}>{l}</option>)}
          </select>
        </div>

        {/* Контейнер с квадратиками */}
        <div
          className={styles.squaresScroll}
          onMouseLeave={() => setHovered(h => ({ ...h, receipt: null }))}
        >
          {receipts.map((r, idx) => {
            const now = new Date(r.status_changed_at).getTime();
            const delta = lastTime != null ? now - lastTime : null;
            lastTime = now;
            return (
              <div
                key={r.id}
                className={styles.squareWrapper}
                onMouseEnter={e => setHovered({ receipt: r, order: idx+1, delta, x: e.clientX, y: e.clientY })}
                onMouseMove={e => setHovered(h => h.receipt===r ? { ...h, x: e.clientX, y: e.clientY } : h)}
              >
                <div className={`${styles.statusSquare} ${styles[statusColors[r.status]]}`} />
              </div>
            );
          })}
        </div>

        <button className={styles.executeButton} onClick={saveChanges} disabled={saving}>
          {saving ? 'Сохранение...' : 'Исполнен'}
        </button>
      </div>

      {/* Тултип рендерится здесь, вне .content */}
      {hovered.receipt && (
        <div className={styles.tooltip} style={{ top: hovered.y + 12, left: hovered.x + 12 }}>
          <PopupContent
            receipt={hovered.receipt}
            orderNumber={hovered.order}
            delta={hovered.delta}
          />
        </div>
      )}
    </>
  );
}
